import {
    ChangeDetectionStrategy,
    Component,
    computed,
    inject,
    input,
} from '@angular/core';
import { MemberComponent } from '@interacta-shared/feature-member';
import { PriorityComponent } from '@interacta-shared/ui';
import { getGenericEmptyUserPlaceholderAsMember } from '@interacta-shared/util-member';
import { asActivityPost } from '@interacta/util-post';
import { UserNotificationEvent } from '@modules/notification/models/user-notification.model';

import { ActivityDateContainerComponent } from '@modules/shared-v2/components/activity-date-container/activity-date-container.component';
import { TranslateService } from '@ngx-translate/core';
import { UserNotificationComponent } from '../user-notification/user-notification.component';

@Component({
    selector: 'interacta-activity-created-or-assigned-notification',
    templateUrl: './activity-created-or-assigned-notification.component.html',
    imports: [
        UserNotificationComponent,
        MemberComponent,
        ActivityDateContainerComponent,
        PriorityComponent,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActivityCreatedOrAssignedNotificationComponent {
    private readonly translateService = inject(TranslateService);

    notification = input.required<UserNotificationEvent>();

    /**
     * WARN this component is configured to handle also to UserNotificationEventType.CREATION
     * we must ensure that the notification is an ActivityPost
     */
    readonly asActivityPost = computed(() => {
        const post = this.notification().post;
        return post && asActivityPost(post);
    });

    readonly emptyMemberPlaceholder = getGenericEmptyUserPlaceholderAsMember(
        this.translateService.instant('DASHBOARD.FILTERS.NOT_ASSIGNED'),
    );
}
